export enum Step {
    Name = 'name',
    Design = 'design',
    Settings = 'settings',
    Notifications = 'notifications',
    Behaviour = 'behaviour',
    Publish = 'publish',
}

export enum StepStatus {
    Active = 'active',
    DoneOpen = 'done-open',
    ContentOnly = 'content-only',
    Default = 'default',
}

export type StepsValidity = {
    [key in Step]: boolean;
}

export type StepsStatuses = {
    [key in Step]: StepStatus;
}
